<template>
  <images-list
    v-bind="$attrs"
    accept=".png,.jpg"
    :auth-token-storage-key="'token'"
    :jwt-body-key="'jwt'"
    :schema="schema"
    :media-u-r-l="mediaURL"
    :query-string="queryString"
    @error="handleError"
  />
</template>

<script>
import { ImagesList } from '@witkac/vue-images';

import { uploadMixin } from '../../mixins/upload';

// @vuese
// @group Components/Forms
// Input na obrazki
export default {
  components: { ImagesList },
  mixins: [uploadMixin]
};
</script>
